export default "__VITE_ASSET__BlyBh8X4__"